module.exports = __webpack_public_path__ + "static/img/album4_202501_03.7648c02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202501_03.jpg
// module id = vp4O
// module chunks = 98